var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Trigger options"}},[_c('v-select',{attrs:{"options":_vm.percents,"reduce":val => val.value,"searchable":false},model:{value:(_vm.trigger.value),callback:function ($$v) {_vm.$set(_vm.trigger, "value", $$v)},expression:"trigger.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }